module.exports = __webpack_public_path__ + "img/msg_no.73753d72.png";